import { z } from 'zod'

export const subscribeFormSchema = z.object({
  firstName: z
    .string()
    .nonempty('First name is a required field.')
    .refine((val) => val.trim() !== '', {
      message: 'First name cannot be empty or just spaces.',
    })
    .default(''),
  lastName: z
    .string()
    .nonempty('Last name is a required field.')
    .refine((val) => val.trim() !== '', {
      message: 'Last name cannot be empty or just spaces.',
    })
    .default(''),
  email: z.string().email('Invalid email address.').default(''),
  address: z
    .string()
    .nonempty('Address is a required field.')
    .refine((val) => val.trim() !== '', {
      message: 'Address cannot be empty or just spaces.',
    })
    .default(''),
  additionalAddress: z.string().optional(),
  state: z
    .string()
    .nonempty('State is a required field.')
    .refine((val) => val.trim() !== '', {
      message: 'State cannot be empty or just spaces.',
    })
    .default(''),
  city: z
    .string()
    .nonempty('City is a required field.')
    .refine((val) => val.trim() !== '', {
      message: 'City cannot be empty or just spaces.',
    })
    .default(''),
  zip: z
    .string()
    .nonempty('ZIP code is a required field.')
    .refine((val) => /^\d{5}$/.test(val.trim()), {
      message: 'Valid ZIP code is invalid.',
    })
    .default(''),
  terms: z
    .boolean()
    .refine((val) => val, {
      message: 'You must agree to the Terms and Privacy Policy to continue.',
    })
    .default(false),
})
